/**
 * HRNotificationSettingsService
 * Admin-only HR notification configuration: per-NotificationType channel toggles
 * and the escalation-contact list. Mirrors TaskManagement's settings surface.
 * Route: api/hr/notifications/{channels|escalation-contacts}
 */
import { BaseService } from '../base/BaseService';
export class HRNotificationSettingsService extends BaseService {
    constructor(http, config) {
        const internalConfig = {
            servicePath: config?.servicePath ?? HRNotificationSettingsService.DEFAULT_SERVICE_PATH,
            basePath: HRNotificationSettingsService.BASE_PATH,
            endpoints: config?.endpoints,
        };
        super(http, internalConfig);
    }
    // -------- channels --------
    async getChannels() {
        const response = await this.getChannelsRaw();
        return response.data ?? [];
    }
    getChannelsRaw() {
        return this.http.get(this.buildUrl('channels'));
    }
    async getChannel(notificationTypeId) {
        const response = await this.getChannelRaw(notificationTypeId);
        return response.data ?? null;
    }
    getChannelRaw(notificationTypeId) {
        return this.http.get(this.buildUrl(`channels/${notificationTypeId}`));
    }
    async upsertChannel(setting) {
        const response = await this.upsertChannelRaw(setting);
        if (!response.data)
            throw new Error('Failed to save channel setting');
        return response.data;
    }
    upsertChannelRaw(setting) {
        return this.http.put(this.buildUrl(`channels/${setting.notificationTypeID}`), setting);
    }
    // -------- escalation contacts --------
    async getEscalationContacts(role, type) {
        const response = await this.getEscalationContactsRaw(role, type);
        return response.data ?? [];
    }
    getEscalationContactsRaw(role, type) {
        const params = {};
        if (role)
            params.role = role;
        if (type)
            params.type = type;
        return this.http.get(this.buildUrlWithParams('escalation-contacts', params));
    }
    async getEscalationContact(id) {
        const response = await this.getEscalationContactRaw(id);
        return response.data ?? null;
    }
    getEscalationContactRaw(id) {
        return this.http.get(this.buildUrl(`escalation-contacts/${id}`));
    }
    async createEscalationContact(contact) {
        const response = await this.createEscalationContactRaw(contact);
        if (!response.data)
            throw new Error('Failed to create escalation contact');
        return response.data;
    }
    createEscalationContactRaw(contact) {
        return this.http.post(this.buildUrl('escalation-contacts'), contact);
    }
    async updateEscalationContact(id, contact) {
        const response = await this.updateEscalationContactRaw(id, contact);
        if (!response.data)
            throw new Error('Failed to update escalation contact');
        return response.data;
    }
    updateEscalationContactRaw(id, contact) {
        return this.http.put(this.buildUrl(`escalation-contacts/${id}`), contact);
    }
    async deleteEscalationContact(id) {
        await this.deleteEscalationContactRaw(id);
    }
    deleteEscalationContactRaw(id) {
        return this.http.delete(this.buildUrl(`escalation-contacts/${id}`));
    }
}
HRNotificationSettingsService.DEFAULT_SERVICE_PATH = 'hr';
HRNotificationSettingsService.BASE_PATH = 'api/hr/notifications';
//# sourceMappingURL=HRNotificationSettingsService.js.map